<template lang="">
   <div class="componente" :style="{width: width, height:heigth, position: position, top:top, left:left }">
     
     <!-- <v-btn class="full">IDIOTA</v-btn> -->
        <div class="full" @mousedown="pulsado(true)" @mouseup="pulsado(false)">
            <v-icon>{{icono}}</v-icon>
        </div>
        <!-- <div class="full" ">
            <v-icon>{{icono}}</v-icon>
        </div> -->
    </div>
</template>
<script>
export default {
    props:{
        heigth: String,
        width: String,
        position: String,
        top:String,
        left: String,
        titulo: String,

        valor:Boolean,
        icono:String
    },

    methods: {
        pulsado(a){
            this.$emit('click',a)      
        }
    },//fin de los métodos

    computed: {
        
    },
    
}
</script>
<style >
    .full{
        height: 100%;
        width: 100%;
        margin: 0 auto;
        background-color: gray;
        align-items: center;
        justify-content: center;
    }
    .full:hover{
        filter: brightness(50%); /* Más oscura*/
    }
    .full:active{
        box-shadow: box-shadow
              7px 6px 28px 1px rgba(0, 0, 0, 0.24);
            transform: translateY(4px);
    }
    .red{
        background-color: red;
    }
    .green{
        background-color: green;
    }
    
</style>